import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from '@common/interfaces/id';
import { IID_GENERIC_OK } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IID_Generic_OkState extends EntityState<IID_GENERIC_OK, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_GENERIC_OK })
@InterfaceDataStore(InterfaceName.GENERIC_OK)
export class IID_Generic_OkStore extends EntityStore<IID_Generic_OkState> {
  constructor() {
    super([]);
  }
}
